import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { API_BASE_URL } from '../../utils/constants'

// Types pour les réponses API
export interface ApiResponse<T> {
  success: boolean
  data: T
  message?: string
}

export interface PaginatedResponse<T> {
  data: {
    items: T[]
    total: number
    active: number
    inactive: number
  }
  success: boolean
  message?: string
}

// Service API principal
export class ApiService {
  public readonly _api: AxiosInstance

  constructor() {
    this._api = axios.create({
      baseURL: API_BASE_URL,
      headers: { 'Content-Type': 'application/json' },
      timeout: 10000,
      withCredentials: true,
    })
  }

  // Méthodes HTTP génériques avec typage
  // T doit représenter exactement la forme du body renvoyé par le backend.
  // Pour les endpoints qui encapsulent dans { success, data: T }, passer ApiResponse<T> comme T.
  async get<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this._api.get<T>(url, config)
    return response.data
  }

  async post<T = unknown>(url: string, data?: unknown): Promise<T> {
    const response = await this._api.post<T>(url, data)
    return response.data
  }

  async postFile<T = unknown>(url: string, formData: FormData): Promise<T> {
    const response = await this._api.post<T>(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60000, // 60 secondes pour l'upload de fichiers
    })
    return response.data
  }

  async patch<T = unknown>(url: string, data?: unknown, config?: { headers?: Record<string, string> }): Promise<T> {
    const response = await this._api.patch<T>(url, data, config)
    return response.data
  }

  async delete<T = unknown>(url: string): Promise<T> {
    const response = await this._api.delete<T>(url)
    return response.data
  }
}
